import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getAllSupportTickets,
  updateSupportTicketStatus,
} from "../../../api/support";
import { Image, notification, Pagination, Space, Spin, Tag } from "antd";
import Back from "./../../../assets/icons/back.svg";
import View from "../../../assets/icons/view.svg";
import DeleteMemberModal from "../../../components/common/modalMember";
import { useDispatch, useSelector } from "react-redux";
import { resetText } from "../../../store/slices/textSlice";
import Table from "../../../components/common/table";
import moment from "moment";
import { ExpandAltOutlined, ExpandOutlined } from "@ant-design/icons";
import TicketDetailsModal from "./ticketDetailsModal";
import StatusDropdown from "../../../components/common/statusDropdown";

const SupportTickets = () => {
  const columns = [
    {
      title: "Ticket No.",
      key: "ticketNumber",
      dataIndex: "ticketNumber",
      render: (text) => <Tag color="purple">{text}</Tag>,
    },
    {
      title: "Name",
      key: "usedId",
      render: (text, record) => (
        <>
          <Space>
            {record?.userId?.role === "USER" ? (
              <Link to={`/main/customers/${record?.userId?._id}`}>
                {record?.userId && record?.userId?._id !== null
                  ? `${record?.userId?.firstName} ${record?.userId?.lastName}`
                  : `${record?.contact?.Name}`}
              </Link>
            ) : (
              <Link
                to={`/main/business-request-detail/${record?.userId?.businessId}`}
              >
                {record?.userId && record?.userId?._id !== null
                  ? `${record?.userId?.firstName} ${record?.userId?.lastName}`
                  : `${record?.contact?.Name}`}
              </Link>
            )}
          </Space>
        </>
      ),
    },
    {
      title: "User Role",
      key: "phoneNumber",
      render: (text, record) => (
        <>
          <Space>
            {record?.userId && record?.userId?.role !== null
              ? record?.userId?.role
              : `N/A`}
          </Space>
        </>
      ),
    },
    // {
    //   title: "Subject",
    //   key: "issueTitle",
    //   dataIndex: "issueTitle",
    // },
    {
      title: "Category",
      key: "supportCategoryId",
      dataIndex: ["supportCategoryId", "name"],
    },
    {
      title: "Reason",
      key: "issueDescription",
      dataIndex: "issueDescription",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (text, record) => (
        <StatusDropdown
          value={record.status}
          onChange={(value) => handleStatusChange(record._id, value)}
        />
      ),
    },
    {
      title: "Attachment",
      key: "image",
      dataIndex: "image",
      render: (text, record) => (
        <>
          {record?.image ? (
            <Space>
              <Image
                src={record?.image}
                width={50}
                height={50}
                preview={true}
                alt="attachment"
                className="rounded object-cover"
              />
            </Space>
          ) : (
            <>N/A</>
          )}
        </>
      ),
    },
    {
      title: "Created At",
      key: "createdAt",
      render: (text, record) =>
        `${moment(record.createdAt).format("MM/DD/YYYY hh:mm A")}`,
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-2">
          <div
            className="w-4 m-auto grid justify-center items-center h-4 rounded-full bg-lightLavender cursor-pointer"
            onClick={() => showModal(record)}
          >
            <ExpandAltOutlined style={{ fontSize: "20px" }} />
          </div>
        </div>
      ),
    },
  ];

  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [render, setRender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [selectedCard, setSelectedCard] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const text = useSelector((state) => state?.text?.value);
  const dispatch = useDispatch();

  const handleStatusChange = async (ticketId, newStatus) => {
    try {
      const response = await updateSupportTicketStatus(ticketId, {
        status: newStatus,
      });
      setSelectedCard(prev => ({
        ...prev,
        status: newStatus
      }));
      setRender((prev) => !prev);
      notification.success({
        message: "Update Successful",
        description: response.message,
      });
    } catch (error) {
      console.error("Error updating status:", error);
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message ||
          error.message ||
          "Failed to update ticket status. Please try again.",
      });
    }
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const showModal = (data) => {
    setIsModalOpen(true);
    setSelectedCard(data);
    // setSelectedId(id);
  };

  const fetchAllTickets = async () => {
    setLoader(true);
    const res = await getAllSupportTickets({
      pageNumber: currentPage,
      itemPerPage: pageSize,
      text: text || null,
    });
    if (res) {
      setData(res);
    }
    setLoader(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    dispatch(resetText());
  }, []);

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  useEffect(() => {
    fetchAllTickets();
  }, [currentPage, pageSize, render, text]);

  const itemRender = (page, type, originalElement) => {
    if (type === "page") {
      return (
        <div
          className={`rounded ${
            currentPage === page
              ? "bg-primaryPurple text-white"
              : "bg-white text-black"
          }`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      );
    }
    return originalElement;
  };

  return (
    <>
      <div>
        <div className="flex items-center ml-2 mt-2 ">
          <span className="text-lg font-medium text-black ml-1">
            Support Tickets (Salesforce)
          </span>
        </div>

        <div>
          <div>
            <div
              className="flex items-start justify-start pt-0"
              data-testid="my-table"
            >
              <Table columns={columns} data={data?.items} loading={loader} />
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center pagination-container mb-2">
          <Pagination
            current={currentPage}
            total={data?.totalItems}
            pageSize={pageSize}
            onShowSizeChange={handleSizeChange}
            pageSizeOptions={[10, 20, 30, 40]}
            onChange={(e) => {
              handlePageChange(e);
            }}
            itemRender={itemRender}
            responsive={true}
            className="custom-pagination"
          />
        </div>
      </div>
      {isModalOpen && (
        <TicketDetailsModal
          issueTitle={selectedCard?.issueTitle}
          details={true}
          issueDescription={selectedCard?.issueDescription}
          attachment={selectedCard?.image}
          user={selectedCard?.userId}
          onCancel={hideModal}
          status={selectedCard?.status}
          onStatusChange={(newStatus) => handleStatusChange(selectedCard._id, newStatus)}
        />
      )}
    </>
  );
};
export default SupportTickets;
